export default "__VITE_ASSET__ece22a34__"